import { makeAutoObservable, runInAction } from "mobx";
import {
  reportOnDetectingDrugResistantTbPatients,
  reportPreliminaryReportOnDetectingDrugResistantTbPatients
} from "./LocalReport03Service";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import i18n from "i18n";
import moment from "moment";

export default class LocalReport03Store {
  localReport03Data = null;
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 5;
  keyword = "";
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;
  searchObject = {
    source: null,
    typeTime:null,
    fromYear:null,
    toYear:null,
    fromQuarter:null,
    toQuarter:null,
    fromDate:null,
    toDate:null,
    organization: null,
    administrativeUnit: null,
    region: null,
    viewLevel: null
  };

  //object truyền vào api xem ds bn chi tiết
  openViewListPatient = null;

  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  handleSetSearchObject = (item) => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
    }
    this.searchObject = item;
  }

  updatePageData = (item) => {
    if (item != null) {
      this.page = 1;
      this.keyword = item.keyword;
      this.handleSetSearchObject(item)
      this.search();
    } else {
      this.search();
    }
  };

  search = async () => {
    this.loadingInitial = true;
    var searchObject = {
      keyword: this.keyword,
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      source:this.searchObject?.source,
      typeTime:this.searchObject?.typeTime,
      fromYear:this.searchObject?.fromYear,
      toYear:this.searchObject?.toYear,
      fromQuarter:this.searchObject?.fromQuarter,
      toQuarter:this.searchObject?.toQuarter,
      fromDate:this.searchObject?.fromDate,
      toDate:this.searchObject?.toDate,
      organizationId: this.searchObject?.organization?.id,
      provinceId: this.searchObject?.administrativeUnit?.id,
      regionAdminiId: this.searchObject?.region?.id,
      viewLevel: this.searchObject?.viewLevel,
      orgIds: this.searchObject?.orgIds
    };

    try {
      let res = await reportOnDetectingDrugResistantTbPatients(searchObject);
      runInAction(() => {
        this.localReport03Data = {
          ...searchObject,
          ...res.data,
        };
      })
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
      this.setLoadingInitial(false);
    }
  };
  handleExportExcel = (item) => {
    var searchObj = {
      ...item,
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
      organizationId: item?.organization?.id,
      provinceId: item?.administrativeUnit?.id,
      regionAdminiId: item?.region?.id,
      fromYear:item?.fromYear,
      toYear:item?.toYear,
      fromQuarter:item?.fromQuarter,
      toQuarter:item?.toQuarter,
      fromDate:item?.fromDate,
      toDate:item?.toDate,
      typeTime:item?.typeTime,
      source:item?.source,
    };
    reportPreliminaryReportOnDetectingDrugResistantTbPatients(searchObj).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "BAO_CAO_THEO_DOI_SANG_LOC_NB_LKT_THEO_DIA_PHUONG" + ".xlsx");
      document.body.appendChild(link);
      link.click();
    }).catch(error => {
      console.log(error);
      toast.warning(i18n.t("toast.error"));
    })
  }

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  setOpenViewListPatient = (obj) => {
    if (obj) {
      this.openViewListPatient = {
        ...obj,
        typeTime:this.searchObject?.typeTime,
        source:this.searchObject?.source,
        fromYear:this.searchObject?.fromYear,
        toYear:this.searchObject?.toYear,
        fromQuarter:this.searchObject?.fromQuarter,
        toQuarter:this.searchObject?.toQuarter,
        fromDate:this.searchObject?.fromDate,
        toDate:this.searchObject?.toDate,
        organizationId: this.searchObject?.organization?.id,
        provinceId: this.searchObject?.administrativeUnit?.id,
        regionAdminiId: this.searchObject?.region?.id
      };
    } else {
      this.openViewListPatient = null
    }
  }

  resetStore = () => {
    this.localReport03Data = null
  }

  getDefaultSubject = (obj) => {
    const preTitle = "(VITIMES) "
    const province = obj?.administrativeUnit?.name ? obj.administrativeUnit.name + " - " : ""
    const org = obj?.organization?.name ? obj.organization.name + " - " : ""
    const title = "Báo cáo theo dõi sàng lọc người bệnh lao kháng thuốc (theo địa phương) - "
    let time = "" 
    if (obj.typeTime === 1) {
      time = `từ ${moment(obj?.fromDate).format("DD/MM/YYYY")} đến ${moment(obj?.toDate).format("DD/MM/YYYY")}`;
    }
    if (obj.typeTime === 2) {
      if (obj?.fromQuarter === obj?.toQuarter && obj?.fromYear === obj?.toYear) {
        time = `quý ${obj?.fromQuarter}/${obj?.fromYear}`
      } else {
        time = `từ quý ${obj?.fromQuarter}/${obj?.fromYear} đến quý ${obj?.toQuarter}/${obj?.toYear}`
      }
    }
    return preTitle + province + org + title + time;
  }
  
  // handleExportSampleExcel = () => {
  //   exportimportDetectionReport({}).then((res) => {
  //     const url = window.URL.createObjectURL(new Blob([res.data]));
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "MAU_BAO_CAO_PHAT_HIEN_NB_LKT" + ".xlsx");
  //     document.body.appendChild(link);
  //     link.click();
  //   }).catch(error => {
  //     console.log(error);
  //     toast.warning(i18n.t("toast.error"));
  //   })
  // }
  
}
